{
  "version": 1,
  "asset_id": "50372379-3afb-46fb-b8f0-96c1182723de",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/50372379-3afb-46fb-b8f0-96c1182723de/lecanto-black-shingle-roof-1320w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/50372379-3afb-46fb-b8f0-96c1182723de/lecanto-black-shingle-roof-1320w.avif",
  "original_filename": "lecanto-black-shingle-roof-1320w.avif",
  "size": 204483,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
